import { Form } from '@anytag/shared-atoms';
import { TikTokSignupFormSchema } from './schema';
import { Template } from './Template';
import { TikTokSignupFormProps, TikTokSignupFormValues } from './types';

export const TikTokSignupForm = ({
  onSubmit,
  defaultValues = {
    name: '',
    email: '',
    countryId: 'TH',
    companyUrl: '',
    companyName: '',
    phoneNumber: '',
    acceptTerms: false
  }
}: TikTokSignupFormProps) => (
  <Form.Provider onSubmit={onSubmit} defaultValues={defaultValues} zodSchema={TikTokSignupFormSchema}>
    <Template />
  </Form.Provider>
);

export { type TikTokSignupFormValues };
